<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 8.99947C0.0367355 4.02799 4.11429 0 9.1102 0C11.6449 0 13.9592 1.05236 15.6122 2.68533L17.2653 1.05236C17.5224 0.79834 18 0.979782 18 1.37895V5.95127C18 6.20528 17.8163 6.38672 17.5592 6.38672H12.8571C12.4531 6.38672 12.2694 5.91498 12.5265 5.66096L14.3265 3.91913C13.0041 2.57646 11.1673 1.74183 9.1102 1.74183C5.06939 1.74183 1.76327 5.00777 1.76327 8.99947C1.76327 13.0275 5.06939 16.2571 9.1102 16.2571C11.0204 16.2571 12.7102 15.5676 14.0327 14.4427C14.1796 14.2976 14.4735 14.2976 14.6204 14.4427L15.2449 15.0596C15.4286 15.241 15.4286 15.5314 15.2449 15.7128C13.6286 17.128 11.4612 18.0352 9.1102 17.9989C4.11429 17.9989 0 13.971 0 8.99947Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: 'RefreshIcon',
  };
</script>
